export const numberWithThousands = (n) => {
  const str = n.toString().replace(/,/g, '.');
  const regex = /\B(?=(\d{3})+(?!\d))/g;

  return str.replace(regex, ' ');
};
